import { ComponentPropsWithoutRef, FC } from 'react';
import s from './HeadingV2.module.scss';
import cn from 'classnames';
import { SizeProp } from 'src/shared/types/props';
import { getMarginBottomClass } from 'src/shared/lib/style';

type TextType = 'hero' | 'h1' | 'h2_medium' | 'h3_bold' | 'h3_medium' | 'h3_regular' | 'h4_medium' | 'h4_regular' | 'h4_light' | 'h5'; // ! Figma names
type Tag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span' | 'div'; // ! Actual semantic tags

interface Props extends ComponentPropsWithoutRef<'span'> {
	type: TextType;
	color?: 'dark' | 'light' | 'main';
	tag?: Tag;
	underline?: boolean;
	marginBottom?: SizeProp;
}

export const HeadingV2: FC<Props> = (props) => {
	const {
		type, //
		color = 'dark',
		marginBottom,
		tag = 'span',
		underline,
		className,
		children,
	} = props;

	const marginBottomStyle = getMarginBottomClass(marginBottom);

	const componentProps = {
		className: cn(
			s.container, //
			s[`container_${type}`],
			s[`container_${color}`],
			!underline && marginBottomStyle,
			className,
		),
	};

	const renderHeading = () => {
		switch (tag) {
			case 'h1':
				return <h1 {...componentProps}>{children}</h1>;
			case 'h2':
				return <h2 {...componentProps}>{children}</h2>;
			case 'h3':
				return <h3 {...componentProps}>{children}</h3>;
			case 'h4':
				return <h4 {...componentProps}>{children}</h4>;
			case 'h5':
				return <h5 {...componentProps}>{children}</h5>;
			case 'h6':
				return <h6 {...componentProps}>{children}</h6>;
			case 'span':
				return <span {...componentProps}>{children}</span>;
			case 'div':
				return <div {...componentProps}>{children}</div>;
		}
	};

	// * Render
	return (
		<>
			{renderHeading()} {underline && <hr className={marginBottomStyle} />}
		</>
	);
};
